import React, { useEffect, useState } from 'react';
import { MDBBtn, MDBInput, MDBInputGroup } from 'mdb-react-ui-kit';
import { connect, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ProfilePicture from '../../../Components/ProfilePicture';
import { setError, updateUserProfile } from '../action';
import { selectSettingsError } from '../selector';

import style from './style.module.scss';
import { showPopup } from '../../../Containers/App/action';
import { usernameChecker } from '../../../Utils/textHelper';

function Profile({profile, error}) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const initState = {
      name: profile.name,
      username: profile.username,
      newProfilePicture: "",
  }
  const [formData, setFormData] = useState(initState);

  const onInputChange = (e) => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value });
  }
  const onSuccessUpdate = () => {
      toast.success("Profile successfully updated!");
      navigate('/');
  }
  const onClickSubmit = () => {
    if(usernameChecker(formData.username)){
        return dispatch(updateUserProfile(formData, onSuccessUpdate))
    }
    return toast.error(`Your username can only contain letters, numbers and '_'`)
  } 
  const editProfilpic = searchParams.get('profilepic');
  useEffect(()=>{
      if (error) {
          toast.error(error);
          dispatch(setError(null));
      }
      if(editProfilpic){
        dispatch(showPopup({isOpen: true, content: "edit-profile-picture"}));
      }
  },[editProfilpic])

  return (
    <div className={style.container}>
        <div className={style.profilePicture}>
            <ProfilePicture url={profile.profilePicture} isHome={true} onClick={()=> dispatch(showPopup({isOpen: true, content: "edit-profile-picture"}))}/>
        </div>
        <div className={style.box}>
            <div>
                <label>Name</label>
                <MDBInput  value={formData.name} name='name' onChange={onInputChange} />
            </div>
            <div>
                <label>Username</label>
                <MDBInputGroup textBefore='@' noBorder>
                    <input style={{backgroundColor: 'transparent'}} className='form-control' value={formData.username} name='username' onChange={onInputChange}/>
                </MDBInputGroup>
            </div>
            <MDBBtn className={`mt-2 ${style.formBtn}`} onClick={onClickSubmit} >Save Changes</MDBBtn>
        </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
    error: selectSettingsError,
});

export default connect(mapStateToProps)(Profile)